import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { platformStatsFbPagePostDaily_template } from "../components/templates/platformStatsFbPagePostDaily_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class platformStats_fbPage_postDaily extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected platformStats_fbPage_postDaily: platformStatsFbPagePostDaily_template;

    protected getModuleName(){
        return "platformStats_fbPage_postDaily";
    }

    buildContent() : Array<Element>{

        this.platformStats_fbPage_postDaily = new platformStatsFbPagePostDaily_template( "platformStats_fbPage_postDaily", this.viewModel, this );

        return [ this.platformStats_fbPage_postDaily.build()];
    }

    public fillPage() : void{

        this.platformStats_fbPage_postDaily.activateLoading();

        let params: Array<Array<string>> = [];
        //params.push(["data", ko.toJSON(this.home.getViewModelForRequest())] );

        let XHRHdl = new XMLHttpRequestHandler('/api/searchConsoleStats/', params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        let _myThis = this;

        XHRHdl.onReadyStateFunction = _myThis.onGetFillPageReturn;
        XHRHdl.execute();
    }


    protected onGetFillPageReturn(req: any, obj: platformStats_fbPage_postDaily) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.platformStats_fbPage_postDaily.setDate(responseParsed.date);
                obj.platformStats_fbPage_postDaily.setBrands(responseParsed.brands);
                obj.platformStats_fbPage_postDaily.setStats(responseParsed.data);
            });

            if(req.request.readyState == 4){

                obj.platformStats_fbPage_postDaily.deactivateLoading();
            }
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/platformStats_fbPage_postDaily.ts